export const SET_COLORS = 'SET_COLORS';
